
import { isMobile } from "../../utils"; 
import { CloseOutlined } from "@ant-design/icons";
import {
  CustomDrawer,
  ContentWrapper,
  CloseButton,
  QRCodeWrapper,
  Title,
  Description,
  ContainerTitle,
} from "./styles";
import qrcode from "../../assets/qrcode.png";

interface IDownloadModalProps {
  visible: boolean;
  setVisible: Function;
}

const DownloadModal = ({ visible, setVisible }: IDownloadModalProps) => {
  const onClose = () => setVisible(false);

  if (visible && isMobile()) {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=br.com.velotax.irpf.app&pcampaignid=web_share";
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.href =
        "https://apps.apple.com/br/app/velotax-irpf/id6499226151";
    }

    return null;
  }

  return (
    <>
      <CustomDrawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        width={480}
      >
        <CloseButton onClick={onClose}>
          <CloseOutlined style={{ color: "#1677FF", fontSize: "32px" }} />
        </CloseButton>

        <ContentWrapper>
          <ContainerTitle>
            <Title>
              Abra sua conta em <strong>poucos minutos</strong>
            </Title>
            <Description>
              Ligue a câmera do celular e aponte para o QR Code abaixo para ser
              redirecionado à loja de aplicativos, depois baixe o app do Velotax
              e abra sua conta.
            </Description>
          </ContainerTitle>
          <QRCodeWrapper>
            <img src={qrcode} width={320} height={320} />
          </QRCodeWrapper>
        </ContentWrapper>
      </CustomDrawer>
    </>
  );
};

export default DownloadModal;
